module.exports = __webpack_public_path__ + "img/bag-fill.8edaa390.svg";